import React from 'react';
import { isHorizontalScrollbarClick } from './isHorizontalScrollbarClick';
import { shouldSkipMultiSelectWrapperClick } from './shouldSkipMultiSelectWrapperClick';

interface MultiSelectWrapperMouseDownOptions {
  isMultiselect: boolean;
  openPopover: () => void;
  focusMultiSelectInputToEnd: () => void;
  scrollContainerSelector: string;
  chipRemoveSelector: string;
  fullscreenTriggerSelector: string;
}

// Handles mousedown on the multiselect wrapper: opens the popover and refocuses
// the Chips input without blurring it, while ignoring chip-remove, fullscreen,
// and horizontal scrollbar interactions.
export const onMultiSelectWrapperMouseDown = (
  event: React.MouseEvent<HTMLDivElement>,
  options: MultiSelectWrapperMouseDownOptions
): void => {
  const {
    isMultiselect,
    openPopover,
    focusMultiSelectInputToEnd,
    scrollContainerSelector,
    chipRemoveSelector,
    fullscreenTriggerSelector,
  } = options;

  if (!isMultiselect || !(event.target instanceof HTMLElement)) {
    return;
  }

  if (
    shouldSkipMultiSelectWrapperClick(
      event.target,
      chipRemoveSelector,
      fullscreenTriggerSelector
    ) ||
    isHorizontalScrollbarClick(event, event.target, scrollContainerSelector)
  ) {
    return;
  }

  // Keep the whole wrapper clickable without blurring the active Chips input.
  event.preventDefault();
  openPopover();
  focusMultiSelectInputToEnd();
};
